import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { JobListModel } from '../models/JobListModel';
import { JobModel } from '../models/JobModel';
import { QueryResponse } from '../../core/services/QueryResponse';
import { ModelResponse } from '../../core/services/ModelResponse';
import { BaseAddressInterceptor } from '../../core/interceptors/BaseAddressInterceptor';
import { AdvancedFilterModel } from '../models/AdvancedFilterModel';
import { FilterPageViewModel } from '../models/FilterPageViewModel';
import { JobWorkSpacePageViewModel } from '../models/JobWorkSpacePageViewModel';
import { JobExportModel } from '../models/JobExportModel';
import { LookupModel } from '../../common/models/LookupModel';
import * as moment from 'moment';
import { ResponseMessage } from '../../core/services/ResponseMessage';
import { DatabaseJobsModel } from '../models/DatabaseJobsModel';
import { DownloadFileService } from '../../common/utilities/DownloadFileService';

@Injectable()
export class JobsService {
  constructor(public httpClient: HttpClient, private downloadFileService: DownloadFileService) {}

  getJobList(page: number, pageSize: number, sort: string, sortDirection: string, searchTerm: string, model: AdvancedFilterModel = null): Observable<QueryResponse<JobListModel>> {
    var filterPageViewModel = new FilterPageViewModel();
    filterPageViewModel.skip = page * pageSize;
    filterPageViewModel.take = pageSize;
    filterPageViewModel.sort = sort;
    filterPageViewModel.sortDirection = sortDirection;
    filterPageViewModel.searchTerm = searchTerm;
    if (model != null) {
      filterPageViewModel.model = model;
    }
    return this.httpClient.post<QueryResponse<JobListModel>>('/api/SubmissionModule/Job/ListQuery', filterPageViewModel);
  }

  getJob(model: JobWorkSpacePageViewModel): Observable<ModelResponse<JobModel>> {
    return this.httpClient.post<ModelResponse<JobModel>>('/api/SubmissionModule/Job/Workspace/', model);
  }

  reprocessJobSubmission(key: string): Observable<ModelResponse<string>> {
    return this.httpClient.get<ModelResponse<string>>('/api/SubmissionModule/Job/Reprocess/' + key);
  }

  cancelJobSubmission(key: string, jobKey): Observable<ModelResponse<string>> {
    return this.httpClient.post<ModelResponse<string>>(`/api/SubmissionModule/Job/${key}/Cancel/`, { model: jobKey });
  }

  getJobStatuses(): Observable<ModelResponse<LookupModel[]>> {
    return this.httpClient.get<ModelResponse<LookupModel[]>>(`/api/SubmissionModule/Job/GetStatuses`);
  }

  getJobDataSets(): Observable<ModelResponse<LookupModel[]>> {
    return this.httpClient.get<ModelResponse<LookupModel[]>>(`/api/SubmissionModule/Job/GetDataSets`);
  }

  getUploadUrl(key: string, fileName: string, contentType: string): Observable<ModelResponse<string>> {
    return this.httpClient.get<ModelResponse<string>>(`/api/SubmissionModule/Job/GetUploadUrl/${key}/${fileName}?contentType=${contentType}`);
  }

  fileUploaded(key: string, url: string): Observable<any> {
    return this.httpClient.post<any>(`/api/SubmissionModule/Job/FileUploaded/${key}`, { url });
  }

  export(model: JobExportModel): Observable<ModelResponse<JobExportModel>> {
    return this.httpClient.post<Blob>(`/api/SubmissionModule/Job/Export`, model, { responseType: 'blob' as 'json', observe: 'response' }).map((r) => {
      this.downloadFileService.export(r, model);
      var response = new ModelResponse<JobExportModel>();
      response.model = model;
      return response;
    });
  }

  openExtract(url: string, model: any): void {
    this.downloadFileService.openExtract(url, model);
  }

  triggerDatabaseJobs(model: DatabaseJobsModel): Observable<ModelResponse<string>> {
    return this.httpClient.post<ModelResponse<string>>(`/api/SubmissionModule/Job/TriggerDatabaseJobs`, model);
  }

  getJobExportToExcel(key: string): Observable<ModelResponse<JobExportModel>> {
    return this.httpClient.get<Blob>('/api/SubmissionModule/Job/ExportToExcel/' + key, { responseType: 'blob' as 'json', observe: 'response' }).map((r) => {
      var response = new ModelResponse<JobExportModel>();
      if (key != null){
        var model = new JobExportModel ();
        this.downloadFileService.export(r, model);
        response.model = model;
        return response;
      }
    });
  }

  getJobExportToPdf(key: string): Observable<ModelResponse<JobExportModel>> {
    return this.httpClient.get<Blob>('/api/SubmissionModule/Job/ExportToPDF/' + key, { responseType: 'blob' as 'json', observe: 'response' }).map((r) => {
      var response = new ModelResponse<JobExportModel>();
      if (key != null){
        var model = new JobExportModel ();
        this.downloadFileService.export(r, model);
        response.model = model;
        return response;
      }
    });
  }

  getJobExportToXml(key: string): Observable<ModelResponse<JobExportModel>> {
    return this.httpClient.get<Blob>('/api/SubmissionModule/Job/ExportToXML/' + key, { responseType: 'blob' as 'json', observe: 'response' }).map((r) => {
      var response = new ModelResponse<JobExportModel>();
      if (key != null){
        var model = new JobExportModel ();
        this.downloadFileService.export(r, model);
        response.model = model;
        return response;
      }
    });
  }

  RestartJob(key: string): Observable<string> {
    return this.httpClient.get<string>('/api/SubmissionModule/Job/RestartJob/' + key);
  }
}



// WEBPACK FOOTER //
// ./src/app/submission/services/JobsService.ts